import { Injectable } from '@angular/core';
import { ServiceOrderItem } from '../../../models/service-order-item';

export interface ServiceOrderState {
    isActive: boolean;
    isCompleted: boolean;
    archived: boolean;
}

@Injectable({ providedIn: 'root' })
export class FuelreqsBusinessLogicService {
  
  /**
   * Determines the archived status and service order state based on completed services
   * Pure function - easily testable
   */
  calculateServiceOrderState(
    numberOfCompletedItems: number,
    numberOfTotalServices: number
  ): ServiceOrderState {
    if (numberOfCompletedItems === 0) {
      return {
        isActive: false,
        isCompleted: false,
        archived: false
      };
    }
    
    if (numberOfCompletedItems === 1 && numberOfTotalServices > 1) {
      return {
        isActive: true,
        isCompleted: false,
        archived: false
      };
    }
    
    if (numberOfCompletedItems === numberOfTotalServices) {
      return {
        isCompleted: true,
        isActive: false,
        archived: true
      };
    }
    
    return {
      isCompleted: false,
      isActive: true,
      archived: false
    };
  }

  /**
   * Formats service items for confirmation dialog
   * Pure function - easily testable
   * Note: Creates a copy of the array to avoid side effects
   */
  formatServiceItemsForConfirmation(serviceOrderItems: ServiceOrderItem[]): string[] {
    // Create a copy to avoid modifying the original array
    const itemsCopy = [...serviceOrderItems];
    const fuelService = itemsCopy.find(f => f.serviceName.indexOf("Fuel: ") > -1);
    const otherServices = itemsCopy.filter(f => f.serviceName.indexOf("Fuel: ") === -1);
    const sortedServices = [...otherServices].sort((a, b) => a.serviceName.localeCompare(b.serviceName));
    const orderedServices = fuelService ? [fuelService, ...sortedServices] : sortedServices;
    
    return orderedServices.map(item => {
      const serviceDescription = (item as any).serviceDescription;
      return serviceDescription == undefined 
        ? `<strong>${item.serviceName}</strong>`
        : `<strong>${item.serviceName}</strong>: ${serviceDescription}`;
    });
  }

  /**
   * Determines PPG display string based on source
   * Pure function - easily testable
   */
  getPPGDisplayString(fuelreq: any, formattedPpg: string): string {
    return (fuelreq.source === 'FuelerLinx' || fuelreq.source === '')
      ? formattedPpg
      : "CONFIDENTIAL";
  }
}

